import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "./Table.css";
import { FormattedMessage } from "react-intl";
import { ExcelModule } from "../../../misc";

const Table = (props: any) => {

    const onSuscribeDownloadData = () => {
        const exportData: any[] = props.Data && props.Data.length > 0 ? props.Data : undefined;

        try {
            // console.log('Click Download', exportData);

            if (exportData) {
                let ExportElements: any[] = new Array<any>();

                [].forEach.call(exportData, (elemento: any, indice: number) => {
                    ExportElements.push({
                        'Guía': elemento.Name,
                        'Productos Asociados': elemento.ProductsRelated,
                        'Talles Recomendados': elemento.Recommended,
                        'Talle Más Recomendado': elemento.SizeMostRecommended,
                        'Encontró Talle': elemento.FoundSize + '%',
                        'No Encontró Talle': elemento.NotFoundSize + '%',
                    });
                });

                if (ExportElements && ExportElements.length > 0) {
                    ExcelModule.ExportTo(
                        ExportElements,
                        "ReportSizesguide",
                        "ReadySize_ReportSizesguide"
                    );
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

  return (
    <div className="table-fitprenda-content">
        <DataTable
              value={(props.isLoadingData ? [] : props.Data)}
              responsiveLayout="scroll"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLinks LastPageLinks CurrentPageLinks RowsPerPageDropdown"
              dataKey="id"
              loading={props.isLoadingData || false}
              emptyMessage="No data found."
              className="datatable-responsive"
              currentPageReportTemplate="Showing {first} to {last} of {total} posts"
              rows={10}
              sortField={"Recommended"}
              sortOrder={-1}
        >
            <Column
              field="Name"
              sortable
              header={
                <FormattedMessage id="ready-size-guide" defaultMessage="Guía" />
              }
            />
        <Column
            field="ProductsRelated"
          sortable
          header={
            <FormattedMessage
              id="ready-size-associated-products"
              defaultMessage="Productos Asociados"
            />
          }
        ></Column>
        <Column
                  field="Recommended"
                  sortable
          header={
            <FormattedMessage
              id="table-TallesRecomendados"
              defaultMessage="Talles recomendados"
            />
          }
        ></Column>
        <Column
                  field="SizeMostRecommended"
          sortable
          header={
            <FormattedMessage
              id="table-TalleMásRecomendado"
              defaultMessage="Talle más recomendado"
            />
          }
        ></Column>
        <Column
                  field="FoundSize"
                  body={(rowData: any) => { return rowData.FoundSize.toString() + '%'; } }
          sortable
          header={
            <FormattedMessage
              id="table-EncontróTalle"
              defaultMessage="Encontró talle"
            />
          }
        ></Column>
        <Column
                  field="NotFoundSize"
                  body={(rowData: any) => { return rowData.NotFoundSize.toString() + '%'; }}
          sortable
          header={
            <FormattedMessage
              id="table-NoEncontróTalle"
              defaultMessage="No encontró talle"
            />
          }
        ></Column>
      </DataTable>
      <div className="dashboard-table-container-descarga">
              <p onClick={() => onSuscribeDownloadData() }>
          {" "}
          <FormattedMessage
            id="table-descargar"
            defaultMessage="Descargar reporte completo"
          />{" "}
        </p>
      </div>
    </div>
  );
};

export default Table;
